import {HttpParams} from '@angular/common/http';

export class FiltroSgsia {
    public page: number;
    public pageSize: number;
    public order: string;
    public orderBy: string;

    getAsHTTPParams(): HttpParams {
        let params = new HttpParams();
        if (this.page != null) {
            params = params.set('page', this.page.toString());
        }
        if (this.pageSize != null) {
            params = params.set('pageSize', this.pageSize.toString());
        }
        if (this.order != null) {
            params = params.set('order', this.order);
        }
        if (this.orderBy != null) {
            params = params.set('orderBy', this.orderBy);
        }
        return params;
    }
}
